import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import '../../assets/css/admin/allcourses.css';
import Swal from 'sweetalert2';
import axios from 'axios';

const AllCourses = () => {
    const [courses, setCourses] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredCourses, setFilteredCourses] = useState([]);

    useEffect(() => {
        fetchCourses();
    }, []);    const fetchCourses = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/course/all');
            const data = await response.json();
            setCourses(data);
            setFilteredCourses(data); // Initialize filteredCourses with all courses
        } catch (error) {
            console.error('Error fetching courses:', error);
        }
    };    // Real-time filtering effect
    useEffect(() => {
        if (!searchTerm.trim()) {
            // If search is empty, show all courses
            setFilteredCourses(courses);
            return;
        }
        
        // Filter courses based on multiple fields
        const filtered = courses.filter(course => 
            (course.courseName && course.courseName.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (course.university && course.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (course.duration && course.duration.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        
        setFilteredCourses(filtered);
    }, [searchTerm, courses]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleDelete = (e, courseId) => {
        e.preventDefault();
        console.log(courseId);

        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this course?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`https://api.myskills.lk/course/delete/${courseId}`)
                    .then((response) => {
                        // Update local state after successful deletion
                        const updatedCourses = courses.filter(course => course.id !== courseId);
                        setCourses(updatedCourses);
                        
                        // Also update filtered courses
                        setFilteredCourses(updatedCourses.filter(course => 
                            !searchTerm || 
                            (course.courseName && course.courseName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (course.university && course.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (course.duration && course.duration.toLowerCase().includes(searchTerm.toLowerCase()))
                        ));
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The course has been deleted.",
                            icon: "success"
                        });
                    })
                    .catch((err) => {
                        console.error("Error deleting course:", err);
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the course.",
                            icon: "error"
                        });
                    });
            }
        });
    };

    // const handleEdit = (courseId) => {
    //     // Navigate to edit page or show edit form in place
    //     // For example, navigate to `/edit-course/${courseId}` or show form inline
    //     console.log('Edit course with ID:', courseId);
    // };

    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>                <div className="search-icon-admin admin-course-search">
                    <h1>ALL COURSES</h1>
                    <form>
                        <input 
                            type="text" 
                            value={searchTerm}
                            onChange={handleSearch} 
                            placeholder='Search Item' 
                        />
                        <input type="submit" value="SEARCH" onClick={(e) => e.preventDefault()} />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Course Name</th>
                                    <th>Institute Name</th>
                                    <th>Start Date</th>
                                    <th>Duration</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>                            <tbody>
                                {filteredCourses.length > 0 ? (
                                    filteredCourses.map((course) => (
                                        <tr key={course.id}>
                                            <td>{course.courseName}</td>
                                            <td>{course.university}</td>
                                            <td>{course.startDate ? new Date(course.startDate).toLocaleDateString('en-CA') : ''}</td>
                                            <td>{course.duration}</td>
                                            <td>
                                                {course.website ? (
                                                    <a href={course.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                                ) : (
                                                    <span style={{ color: '#999' }}>No Website</span>
                                                )}
                                            </td>
                                            <td id='action-buttons'>
                                                {/* <a href="#!" id='man-details' onClick={() => handleEdit(course.id)}>EDIT</a> */}
                                                <a href="#!" id='del-details' onClick={(e) => handleDelete(e, course.id)}>DELETE</a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{textAlign: 'center'}}>No courses found matching your search</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllCourses;
